import type { ObservationInvalidateTarget } from "./observation-invalidate.type";

import {
  convertQueryInvalidate,
  type QueryInvalidateTarget,
} from "@/services/query";

export const getObservationInvalidate = (
  observationId: number,
  invalidate: ObservationInvalidateTarget[] = []
): QueryInvalidateTarget[] => {
  return convertQueryInvalidate({
    invalidate,
    getCustomQueryKey: (key) => {
      if (key === "list") return ["observations", "list"];
      if (key === "item") return ["observations", "get", observationId];
      if (key === "comments")
        return ["observations.comments", "list", observationId];
      return undefined;
    },
  });
};
